import { useCallback, useMemo, useState } from 'react'
import { API } from '../../services/api'

export type DeleteAccountConfirmStatus =
  | 'ready'
  | 'loading'
  | 'confirmed'
  | 'invalidLink'
  | 'expired'
export type DeleteAccountConfirmError = 'tooManyRequests' | 'unexpected'

// The API issues 32 random bytes as base64url.
const TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/

export const useDeleteAccountConfirm = (search: string) => {
  const token = useMemo(() => new URLSearchParams(search).get('token'), [search])
  const [status, setStatus] = useState<DeleteAccountConfirmStatus>(() =>
    token !== null && TOKEN_PATTERN.test(token) ? 'ready' : 'invalidLink'
  )
  const [error, setError] = useState<DeleteAccountConfirmError | null>(null)

  const confirm = useCallback(async () => {
    if (token === null || status !== 'ready') return
    setStatus('loading')
    setError(null)
    const response = await API.getInstance().confirmAccountDeletion(token)
    if (response.ok) setStatus('confirmed')
    else if (response.status === 410) setStatus('expired')
    else if (response.status === 400) setStatus('invalidLink')
    else {
      setStatus('ready')
      setError(response.status === 429 ? 'tooManyRequests' : 'unexpected')
    }
  }, [token, status])

  return { status, error, confirm }
}
